<template>
  <div>
    <div class="coupon">
      <div style="text-align: center;margin-bottom: 1rem">
        <img style="width: 100%;height:10rem" :src="data.img" alt="图片" />
      </div>
      <div class="list">
        <div class="title">商家</div>
        <div class="content">{{ data.parking_store_name }}</div>
      </div>
      <van-divider />
      <div class="list">
        <div class="title">名称</div>
        <div class="content">{{ data.name }}</div>
      </div>
      <van-divider />
      <div class="list">
        <div class="title">金额</div>
        <div class="content">{{ data.fee }}</div>
      </div>
      <van-divider />
      <div class="list">
        <div class="title">描述</div>
        <div class="content">{{ data.describe }}</div>
      </div>
      <van-divider />
      <div class="list">
        <div class="title">可用停车场</div>
        <div class="content">{{ data.parking_lot_name }}</div>
      </div>
    </div>
    <div>
      <van-button @click="onReceiveCoupon" style="width: 100%;" type="primary"
        >确认领取</van-button
      >
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getCouponDetail, receiveCoupon } from '@/api/api';
import { Button, Toast, Divider } from 'vant';
export default {
  components: {
    VanButton: Button,
    VanDivider: Divider,
  },
  data() {
    return {
      data: {},
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      total: 0,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.handleGet();
  },
  methods: {
    async handleGet() {
      try {
        const { data } = await getCouponDetail({
          parking_coupon_id: this.userInfo.parking_coupon_id,
        });
        this.data = data;
      } catch {}
    },
    async onReceiveCoupon() {
      try {
        await receiveCoupon({
          parking_coupon_id: this.userInfo.parking_coupon_id,
          parking_coupon_log_id: this.userInfo.parking_coupon_log_id,
        });
        Toast('领取成功');
        this.$router.push({
          name: 'Home',
        });
      } catch {}
    },
  },
};
</script>
<style scoped lang="scss">
.coupon {
  background-color: #fff;
  padding: 1rem;
  margin-bottom: 0.5rem;
  .list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    .title {
      width: 4rem;
      font-size: 0.8rem;
      margin-right: 1rem;
    }
    .content {
      flex: 1;
      font-size: 0.9rem;
    }
  }
}
</style>
